import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { usePopover } from "@website/ui/popover/popover.hook";
import styles from "@website/ui/popover/popover.module.scss";
import { PopoverPropertiesType } from "@website/ui/popover/popover.types";
import { Transition } from "@website/ui/transition";
import { FC } from "react";
export const Popover: FC<PopoverPropertiesType> = properties => {
  const $ = _c(17);
  const {
    animate: t0,
    children,
    hideCloseButton,
    title,
    gap,
    horizontalPosition: t1,
    verticalPosition,
    className,
    headerClassName
  } = properties;
  const animate = t0 === undefined ? "bottom" : t0;
  const horizontalPosition = t1 === undefined ? "start" : t1;
  const {
    isMobile
  } = useViewPort();
  const {
    rootProps,
    transitionProps,
    closeButtonProps,
    popoverOpen,
    animateOpen
  } = usePopover(properties);
  if (popoverOpen) {
    let t2;
    if ($[0] !== animate || $[1] !== children || $[2] !== className || $[3] !== closeButtonProps || $[4] !== gap || $[5] !== headerClassName || $[6] !== hideCloseButton || $[7] !== horizontalPosition || $[8] !== isMobile || $[9] !== rootProps || $[10] !== title || $[11] !== verticalPosition) {
      t2 = state => <div {...rootProps} className={`${styles.popover} ${styles[animate]} ${styles[state]} ${styles[horizontalPosition]} ${styles[verticalPosition]} ${className}`} style={{
        marginTop: isMobile ? "0px" : gap || "0px"
      }}><div className={`${styles.header} ${headerClassName}`}>{title ? <div className={styles.title}>{title}</div> : null}{hideCloseButton ? null : <div className={styles["close-wrapper"]}><MaterialIcon className={styles["close-button"]} name="close" {...closeButtonProps} /></div>}</div>{children}</div>;
      $[0] = animate;
      $[1] = children;
      $[2] = className;
      $[3] = closeButtonProps;
      $[4] = gap;
      $[5] = headerClassName;
      $[6] = hideCloseButton;
      $[7] = horizontalPosition;
      $[8] = isMobile;
      $[9] = rootProps;
      $[10] = title;
      $[11] = verticalPosition;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    let t3;
    if ($[13] !== animateOpen || $[14] !== t2 || $[15] !== transitionProps) {
      t3 = <Transition {...transitionProps} in={animateOpen}>{t2}</Transition>;
      $[13] = animateOpen;
      $[14] = t2;
      $[15] = transitionProps;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    return t3;
  }
  return null;
};